import React, { useEffect, useState } from 'react';
import './GlobalErrorPage.css';
import Button from '../Button';

interface GlobalErrorPageProps {
  onClose: () => void;
  handleGoToLandingPage: () => void;
}

const GlobalErrorPage: React.FC<GlobalErrorPageProps> = ({ onClose, handleGoToLandingPage }) => {
  const [countdown, setCountdown] = useState(50);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onClose();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onClose]);

  return (
    <div className="global-error-overlay">
      <div className="global-error-container">
        <h1 className="global-error-title">Thanks for your patience</h1>

        <p className="global-error-message">
          We couldn't complete the request just now. This event
          has been recorded for our team to review. Please try again shortly.
        </p>

        <p className="global-error-redirect-text">
          You'll be redirected to the previous page automatically in <strong>{countdown}</strong> seconds.
        </p>
        <p className='global-error-redirect-text'>
          (You can also click Back to return immediately or go to Dashboard.)
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button
            onClick={onClose}
            id=""
            buttonName={'Back'}
            colorType={'primary'}
            iconPosition={'right'}
          />
          <Button
            onClick={handleGoToLandingPage}
            id=""
            buttonName={'Dashboard'}
            colorType={'save'}
            iconPosition={'right'}
          />
        </div>
      </div>
    </div>
  );
};

export default GlobalErrorPage;
